const geoMatrixConverter = (x, y, matrix) => {
    const px = x * matrix[0][0] + y * matrix[0][1] + 1 * matrix[0][2];
    const py = x * matrix[1][0] + y * matrix[1][1] + 1 * matrix[1][2];
    return [px, py];
};

export default geoMatrixConverter;
